import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowRight, MapPin, Users } from "lucide-react";
import { Img } from "@/components/shared/Img";
import { fetchRooms } from "@/lib/api";
import { floorLabel } from "@/lib/format";

/** The place as a place: the room's own photo, floor and capacity, and a way in to the room page. */
export const EventVenueCard = ({ ev, className }) => {
  const { data: rooms } = useQuery({ queryKey: ["rooms"], queryFn: fetchRooms, staleTime: 5 * 60_000 });
  const room = (rooms || []).find((r) => r.id === ev.room_id) || (rooms || []).find((r) => ev.location && (r.name === ev.location || r.short_name === ev.location));
  if (!room) return null;
  const img = room.images?.[0];
  return (
    <Link to={`/rom/${room.slug}`} className={`group block overflow-hidden rounded-[16px] border border-border bg-card transition-colors hover:border-foreground/30 ${className || ""}`} data-testid="event-venue-card">
      <div className="flex items-stretch">
        {img && <div className="relative w-28 shrink-0 overflow-hidden bg-secondary sm:w-32"><Img src={img} alt={room.captions?.[img] || room.name} width={480} widths={[240, 480]} sizes="128px" className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.05]" /></div>}
        <div className="min-w-0 flex-1 p-4">
          <p className="t-mono flex items-center gap-1.5 text-muted-foreground"><MapPin className="h-3 w-3" /> Stad</p>
          <p className="mt-1 font-display text-[18px] font-semibold leading-tight tracking-[-0.015em]" data-testid="event-venue-name">{room.name}</p>
          <p className="mt-1 text-[13px] text-muted-foreground">{[floorLabel(room.floor), room.capacity ? `inntil ${room.capacity}` : null].filter(Boolean).join(" · ")}{room.capacity ? <Users className="ml-1 inline h-3 w-3 align-[-1px]" /> : null}</p>
          <p className="u-link mt-2.5 inline-flex items-center gap-1 text-[13.5px] font-medium">Sjå rommet <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" /></p>
        </div>
      </div>
    </Link>
  );
};
